import { Component, OnInit } from '@angular/core';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tos',
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.css']
})
export class TosComponent implements OnInit {

  seoData: SeoSocialShareData = {
    title:  'Terms and Conditions',
    description: 'Welcome to the Nepal Property Services (NEPROSE) website. By using our site, you agree to the following terms of use, which constitute an agreement between NEPROSE and you.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
  }

}
